import axios from 'axios';

import { createFragment } from '@jsmdg/react-fragment-scripts/fragment';
import { type FragmentContext } from '../shared/types/fragmentContext';
import { type PageRoot } from '../shared/types/pageRoot';
import { Page } from './components/Page';
import { createErrorLogger } from './helper/createErrorLogger';
import { fetchProducts } from './services/fetchProducts';
import {
    fetchPlacesDetail,
    fetchPlacesSuggestions,
    performReverseGeocode,
} from './services/placesService';
import { getTenantConfig } from './tenantConfig';

// eslint-disable-next-line @typescript-eslint/require-await
async function initDependencies({ baseUrl }: { baseUrl?: string }): Promise<void> {
    axios.defaults.baseURL = baseUrl;
}

const { Fragment, init } = createFragment<PageRoot, FragmentContext>(
    Page,
    ({ rootComponentProps, locale, tenant }) => {
        const {
            path = '',
            campaignCreatives,
            featureFlagsVariation,
            showBetaFeatures,
            customerState,
            initialWishlist,
            logger,
            env,
            isShoppingFlow,
            isMydays,
            algoliaTracking,
        } = rootComponentProps || {};

        return {
            fetchProducts,
            getPlacesSuggestions: async (input: string, sessionToken: string) =>
                fetchPlacesSuggestions({
                    input,
                    sessionToken,
                    locale,
                }),
            getPlacesDetail: async (placeId: string, sessionToken: string) =>
                fetchPlacesDetail({
                    placeId,
                    sessionToken,
                    locale,
                }),
            reverseGeocode: async (lat: number, long: number) =>
                performReverseGeocode({ lat, long, locale }),
            locale,
            tenant,
            path,
            campaignCreatives,
            featureFlagsVariation,
            showBetaFeatures,
            customerState,
            initialWishlist,
            errorLogger: createErrorLogger(logger),
            tenantConfig: getTenantConfig(tenant),
            isMydays,
            env,
            isShoppingFlow,
            algoliaTracking,
        };
    },
    initDependencies,
);

export { Fragment, init };
